<template>
  <div :class="$utilModalStyle.modalOverlay">
    <div :class="[$utilModalStyle.modalContent, $style.playerRoleModalContent]" @click.stop>
      <div :class="styles.titleContainer">
        <img :src="props.isSaboteur ? comedyIcon : userIcon" alt="role icon" :class="$style.roleIcon" />
        <div :class="styles.title">
          {{ props.isSaboteur ? $t("saboteur") : $t("player") }}
        </div>
      </div>
      <div :class="$style.text1">
        {{ props.isSaboteur ? $t("saboteur-reveal") : $t("player-reveal") }}
      </div>
      <div :class="$style.text2">
        {{
          props.isSaboteur
            ? `${$t("saboteur-role-note")} ${$t("text")} ${props.realTextLabel || "--"}.`
            : $t("player-role-note")
        }}
      </div>
      <div :class="$utilModalStyle.modalActions">
        <!-- <button :class="$globalStyle.secondaryAction" @click="closeModal">I'll Wait</button> -->
        <button :class="$utilModalStyle.primaryAction" @click="props.closeModal">{{ $t("close") }}</button>
      </div>
      <!-- <div :class="$globalStyle.modalHelperText">
        <span>Note:</span> If the timer runs out, the game will automatically proceed to the next
        phase!
      </div> -->
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/PlayerRoleModal.module.css";
import utilModalStyles from "@/css/UtilModal.module.css";
import UserIcon from "@/assets/icons/user.svg";
import ComedyIcon from "@/assets/icons/comedy-red.svg";

const $style = styles;
const $utilModalStyle = utilModalStyles;
const userIcon = UserIcon;
const comedyIcon = ComedyIcon;

// eslint-disable-next-line
const props = defineProps({
  isSaboteur: {
    type: Boolean,
    required: true,
  },
  realTextLabel: {
    type: String,
    required: false,
    default: "",
  },
  closeModal: {
    type: Function,
    required: true,
  },
});
</script>

<style scoped></style>
